<div class="form-group">
  <div class="row fields-group">
    <div class="col-auto">
      <label class="input-label">{{ 'dets.predicate' | translate }}</label>
      <select class="form-control" [(ngModel)]="operator" (ngModelChange)="operatorValueChanged()">
        <option [ngValue]="'NOT_EQUAL'">{{ 'Uploaded' | translate }}</option>
        <option [ngValue]="'EQUAL'">{{ 'Not uploaded' | translate }}</option>
        <option *ngIf="operators.includes('IS_VALID')" [ngValue]="'IS_VALID'">{{ 'IS_VALID' | translate }}</option>
        <option *ngIf="operators.includes('IS_NOT_VALID')" [ngValue]="'IS_NOT_VALID'">{{ 'IS_NOT_VALID' | translate }}</option>
      </select>
    </div>
  </div>
</div>
